import { CounterData05 } from '../../../Components/Counters/CounterData'
import { m } from 'framer-motion'
import { Container} from 'react-bootstrap'
import { fadeIn } from '../../../Functions/GlobalAnimations'
import Counter from '../../../Components/Counters/Counter'

const CounterKera = () => {
    return (
        <>
            <m.section className="bg-lightgray py-[160px] lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px]" {...fadeIn}>
                <Container>
                    <Counter
                        theme="counter-style-05"
                        grid="row-cols-1 row-cols-md-3 text-center gap-y-10"
                        className="text-black"
                        duration={2}
                        data={CounterData05}
                        animation={fadeIn}
                        animationDelay={0.2}
                    />
                </Container>
            </m.section>
        </>
    )
}

export default CounterKera